<template>
<p>
  <strong>
    <span v-if="!$keycloak.hasRealmRole('documentadmin')">{{template.code}}</span>
    <router-link :to="{name:'template', params: {id: template.id}}" v-if="$keycloak.hasRealmRole('documentadmin')">{{template.code}}</router-link>
  </strong>
  <span> - {{template.name}}</span>
</p>
</template>

<script>
export default {
  name: "TemplateLink",
  props: ["template"]
}
</script>
